import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import MapResultsGrid from 'src/components/pages/map/tabs/items/all/MapResultsGrid'
import { useGetMapPropertiesQuery } from 'src/redux/api'
import { FRESH_LISTINGS_COUNT } from '../fresh/FreshListings'
import ErrorState from 'src/components/elements/error-state/ErrorState'

const FEED_SIZE = 24

// The full listings feed at the bottom of the home page (owner feedback: the
// home page should end with more listings, not just the short fresh strip).
// Same cards as the map results grid; hidden while there is nothing to show.
// It continues after the fresh strip: with the same newest-first order its
// first eight cards used to repeat the strip right above it.
const AllListings: FC = () => {
  const { t } = useTranslation()
  const { data, isError, refetch } = useGetMapPropertiesQuery({
    sort: 'createdAt desc',
    limit: FEED_SIZE + FRESH_LISTINGS_COUNT,
  })
  const items = (data?.properties || []).slice(FRESH_LISTINGS_COUNT)

  if (isError) {
    return (
      <section className="flex flex-col gap-3">
        <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {t('home_all.title')}
        </h2>
        <ErrorState onRetry={refetch} />
      </section>
    )
  }
  if (items.length === 0) return null

  return (
    <section className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {t('home_all.title')}
        </h2>
        <Link
          to="/map"
          className="shrink-0 inline-flex items-center min-h-11 text-sm font-extrabold text-brand-ink hover:underline"
        >
          {t('home_all.see_all')} →
        </Link>
      </div>
      <MapResultsGrid properties={items} mobileCarousel />
    </section>
  )
}

export default AllListings
